import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';
import {PublisherLinkInterface} from '../models/links/publisher-link-interface';
import {Vertical} from '../models/links/vertical';

@Injectable({
  providedIn: 'root'
})
export class VerticalService {
  private http = inject(HttpClient);


  apiUrl = '/api/verticals';
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  /**
   * Observable for preferences
   */
  protected verticalObservable: Observable<PublisherLinkInterface>;

  public get(): Observable<Vertical[]> {
    return this.http.get<Vertical[]>(`${this.apiUrl}`);
  }

  public delete(id): Observable<Vertical[]> {
    return this.http.delete<Vertical[]>(`${this.apiUrl}`, {params: {id}});
  }

  public create(name): Observable<Vertical[]> {
    return this.http.put<Vertical[]>(`${this.apiUrl}`, {name});
  }

  public update(vertical: Vertical): Observable<Vertical[]> {
    return this.http.post<Vertical[]>(`${this.apiUrl}`, vertical);
  }
}
